import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { apiService } from '../services/api';

// Fix for the marker icon in react-leaflet
import L from 'leaflet';
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  
  const [status, setStatus] = useState({
    submitted: false,
    submitting: false,
    info: { error: false, msg: null }
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({
      submitted: false,
      submitting: true,
      info: { error: false, msg: null }
    });

    try {
      // Use the correct apiService method
      await apiService.sendContactMessage(formData);
      
      setStatus({
        submitted: true,
        submitting: false,
        info: { error: false, msg: 'Message sent successfully!' }
      });
      
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
    } catch (error) {
      setStatus({
        submitted: false,
        submitting: false,
        info: { error: true, msg: 'An error occurred. Please try again later.' }
      });
      console.error('Error sending message:', error);
    }
  };

  // Add your office coordinates here
  const position = [36.7525, 3.0420]; // Example: Algiers coordinates

  return (
    <Container  className="py-5 mt-5">
      <Row className="mb-5">
        <Col>
          <h2 className="text-center">Nous contacter</h2>
          <p className="lead text-center">
          Contactez-nous pour toute question.
          </p>
        </Col>
      </Row>

      <Row>
        <Col md={6} className="mb-4">
          <h3>Informations de contact</h3>
          <p>
          N’hésitez pas à nous contacter en utilisant le formulaire de contact ou les informations ci-dessous.
          Notre équipe est à votre disposition pour répondre à vos questions.
          </p>
          
          <div className="mt-4">
            <p>
              <i className="fas fa-map-marker-alt me-2"></i>
              123 Main Street, City, State ZIP
            </p>
            <p>
              <i className="fas fa-phone me-2"></i>
              (123) 456-7890
            </p>
            <p>
              <i className="fas fa-envelope me-2"></i>
              info@delta.com
            </p>
          </div>
          
          <div className="mt-4">
            <h4>Suivez-nous</h4>
            <div className="d-flex">
              <a href="#" className="me-3 text-dark">
                <i className="fab fa-facebook-f fa-2x"></i>
              </a>
              <a href="#" className="me-3 text-dark">
                <i className="fab fa-twitter fa-2x"></i>
              </a>
              <a href="#" className="me-3 text-dark">
                <i className="fab fa-linkedin-in fa-2x"></i>
              </a>
              <a href="#" className="text-dark">
                <i className="fab fa-instagram fa-2x"></i>
              </a>
            </div>
          </div>
        </Col>
        
        <Col md={6}>
          <h3>Envoyez-nous un message</h3>
          
          {status.info.error && (
            <Alert variant="danger">
              {status.info.msg}
            </Alert>
          )}
          
          {status.submitted && !status.info.error && (
            <Alert variant="success">
              {status.info.msg}
            </Alert>
          )}
          
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </Form.Group>
            
            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </Form.Group>
            
            <Form.Group className="mb-3">
              <Form.Label>Subject</Form.Label>
              <Form.Control
                type="text"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                required
              />
            </Form.Group>
            
            <Form.Group className="mb-3">
              <Form.Label>Message</Form.Label>
              <Form.Control
                as="textarea"
                rows={5}
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
              />
            </Form.Group>
            
            <Button
              variant="primary"
              type="submit"
              disabled={status.submitting}
            >
              {status.submitting ? 'Envoi...' : 'Envoyer message'}
            </Button>
          </Form>
        </Col>
      </Row>
      
      {/* Add the map */}
      <div className="mt-4" style={{ height: '300px', width: '100%' }}>
        <MapContainer 
          center={position} 
          zoom={13} 
          style={{ height: '100%', width: '100%', borderRadius: '8px' }}
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          />
          <Marker position={position}>
            <Popup>
              Delta Trae<br />
              Notre bureau principal
            </Popup>
          </Marker>
        </MapContainer>
      </div>
    </Container>
  );
}

export default Contact;